/**
 * Fixed-point world units (CLAUDE.md §4.2). Everything in the simulation is an
 * integer. One map tile is TILE units on a side; unit positions are in units.
 */
export const TILE = 256;

export function tileToUnits(tile: number): number {
  return tile * TILE;
}

/** Center of a tile, in units. */
export function tileCenter(tile: number): number {
  return tile * TILE + TILE / 2;
}

export function unitsToTile(units: number): number {
  return Math.floor(units / TILE);
}

/** Integer division truncating toward zero. */
export function idiv(a: number, b: number): number {
  return Math.trunc(a / b);
}

/** Integer square root (floor), Newton's method. Deterministic on every engine. */
export function isqrt(n: number): number {
  if (n <= 0) return 0;
  let x = n;
  let y = Math.floor((x + 1) / 2);
  while (y < x) {
    x = y;
    y = Math.floor((x + Math.floor(n / x)) / 2);
  }
  return x;
}
